import styled from '@emotion/styled';

export const Caption = styled.h3`
	font-weight: 800;
	font-size: 24px;
	line-height: 28px;
	color: rgba(27, 31, 59, 0.8);
	margin: 0 0 32px;
`;
